import { useRequest } from '@hourly/hooks/useRequest';
import { AxiosError } from 'axios';
import { useState } from 'react';
import { User } from '../models/users.model';
import { editUser as editUserRequest } from '../requests/editUser.request';
import { getParnerUsers } from '../requests/users.request';

interface EditUserArgs {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  mobileNumber: string;
}

export function useUsers(partnerId: string) {
  const [users, setUsers] = useState<User[]>([]);
  const [editUserErrorMessage, setEditUserErrorMessage] = useState<string | undefined>();

  const { request: fetchUsers, status } = useRequest(
    async () => {
      if (!partnerId) {
        return;
      }
      setUsers(await getParnerUsers(partnerId));
    },
    { requestOnMount: true }
  );

  const { request: editUser } = useRequest(
    async (user: EditUserArgs) => {
      if (!user || !partnerId) {
        return;
      }

      setEditUserErrorMessage(undefined);
      await editUserRequest(partnerId, user.id, user);
      fetchUsers();
    },
    {
      onError: (error) => {
        const axiosError = error as AxiosError<{ error_detailed_message?: string }>;
        const errorMessage =
          axiosError.response?.data?.error_detailed_message ?? 'Unexpected error occurred';
        setEditUserErrorMessage(errorMessage);
      },
    }
  );

  return {
    users,
    isFetchUsersSettled: status.isError || status.isSuccess,
    editUser,
    editUserErrorMessage,
    clearEditUserError: () => setEditUserErrorMessage(undefined),
  };
}
